import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import useAuthStore from "../../store/auth.store";
import Home from "./Home";

export default function RootGate() {
  const { isAuthenticated, loading, user } = useAuthStore();
  const userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";
  const isElectron = userAgent.includes("Electron");

  // The auth store hydrates from session cookie on mount; show a spinner
  // during the auth probe so we can decide between landing + Electron-
  // redirect with the right authentication state.
  if (loading) {
    return (
      <div className="min-h-[100dvh] bg-bg-main text-text-primary flex items-center justify-center">
        <div className="flex items-center gap-2 text-text-secondary text-sm">
          <Loader2 className="w-4 h-4 animate-spin" />
          <span>Loading…</span>
        </div>
      </div>
    );
  }

  // STANDBY accounts always land on /maintenance regardless of how
  // they arrived at the site.
  const isStandby = isAuthenticated && user?.status === "STANDBY";
  if (isStandby) {
    return <Navigate to="/maintenance" replace />;
  }

  // Electron desktop app is a thin shell over the SPA and has no
  // marketing landing — keep its current behaviour (sign-in or
  // dashboard depending on auth). Authed superusers go to Owner
  // Console; everyone else to the customer dashboard.
  if (isElectron) {
    const authedHome = user?.is_superuser ? "/admin" : "/dashboard";
    return (
      <Navigate to={isAuthenticated ? authedHome : "/login"} replace />
    );
  }

  // 2026-06-10 founder ask — `/` ALWAYS shows the marketing landing
  // page, regardless of auth state. Previously authed users were
  // auto-redirected to /dashboard (or /admin) which made the brand
  // wordmark unable to reach the landing and made post-logout back-
  // button behaviour confusing. The landing's navbar now shows
  // "Go to your dashboard" for authenticated users so they can still
  // step into the app in one click.
  return <Home />;
}
